import client from '../client';

export const _createUserTask = async (user_id, lead_id, task, due_date) => {
  return await client.post(
    `user-tasks/${user_id}`,
    { task, due_date, lead_id, status: 'pending' },
    { credentials: 'omit' }
  );
};

export const _updateUserTaskStatus = async (user_id, id, status) => {
  return await client.patch(`user-tasks/${user_id}/${id}`, { status }, { credentials: 'omit' });
};

export const _getUserTasks = async (user_id, status = '') => {
  const _status = status ? `?status=${status}` : '';
  return await client.get(`user-tasks/${user_id}${_status}`, {}, { credentials: 'omit' });
};
